import IAddress1UnitNoZipCode from './IAddress1UnitNoZipCode';

export default {
    /**
     * Compare the fields of the given source against the given target.
     * @param source
     * @param target
     * @returns true on all fields are equal, false otherwise
     */
    matches(source: IAddress1UnitNoZipCode, target: IAddress1UnitNoZipCode): boolean {
        if (source.address1.toLowerCase() !== target.address1.toLowerCase()) {
            return false;
        }
        if (source.unitNumber.toLowerCase() !== target.unitNumber.toLowerCase()) {
            return false;
        }
        if (source.zipCode.toLowerCase() !== target.zipCode.toLowerCase()) {
            return false;
        }

        return true;
    }
};
